import { api } from '../services/api'

export class GerarPedidoOrcamentoService {
  constructor() {
    this.api = api
  }

  async solicitarCaricatura(data) {
    const response = await api.post('/site/v2/orcamento-crm/solicita-caricatura', data)

    if (response.status !== 200) {
      throw new Error(response.data.erros)
    }

    return response.data
  }
}
